import React from 'react'
import style from "./style/Certificate.module.css"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import pictureFrontEndBasic from "./picturesOfCertificates/frontEndBasic.png"
import svgIconCss from "./svgIcons/css3.svg"
import { Button } from '@mui/material';
import pictureFrontEndPro from "./picturesOfCertificates/frontEndPro.png"
import svgIconJs from "./svgIcons/jsIcon.svg"
import certificateFrontBasicPdf from "./certificatePDF/frontEndBasic.pdf"
import certificateFrontProPdf from "./certificatePDF/frontEndPro.pdf"

function Certificate() {
    

    return (
            <div className={style.wrapper}>
                <div className={style.container}>
                    <header className={style.header}>
                        <div className={style.container}>
                            <nav className={style.nav}>
                                <Link style={{display: "flex"}} to="/portfolio"><ArrowBackIcon sx={{
                                    fontSize: "40px",
                                    color: "white",
                                }}/></Link>
                            </nav>
                        </div>
                    </header>
                    <h2 className={style.certificate__h2}>My certificates</h2>
                    <div className={style.certificate}>
                        <div className={style.certificate__content}>
                            <div className={style.certificate__body}>
                                <div className={style.certificate__img}>
                                    <img src={pictureFrontEndBasic} alt="pictureFrontEndBasic" />
                                </div>
                                <div className={style.certificate__description}>
                                    <ul className={style.listDescription}>
                                        <div className={style.listTitle}>
                                            <div className={style.svgTitle}>
                                                <img src={svgIconCss} alt="svgIconCss" />
                                            </div>
                                            <div className={style.descriptionList}>
                                                <h3>Front-end Basic</h3>
                                                <span>15.06-27.08.2022</span>
                                            </div>
                                        </div>
                                        <li>
                                            <p className={style.descriptionLi}>Assessment</p>
                                            <p className={style.appraisal__certificate}>Excelent</p>
                                        </li>
                                        <li>
                                            <p className={style.descriptionLi}>Average score</p>
                                            <p className={style.appraisal__certificate}>100</p>
                                        </li>
                                    </ul>
                                    <ul className={style.listLink}>
                                        <li>
                                            <a href={certificateFrontBasicPdf} download>
                                                <Button variant='contained'>Download</Button>
                                            </a>
                                        </li>
                                        <li>
                                            <a target='_blank' href="https://certificate.ithillel.ua/view/11488204">
                                                <Button variant='contained' sx={{
                                                    padding: "6px 35px"
                                                }}>Open</Button>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={style.certificate__body}>
                                <div className={style.certificate__img}>
                                    <img src={pictureFrontEndPro} alt="pictureFrontEndPro" />
                                </div>
                                <div className={style.certificate__description}>
                                    <ul className={style.listDescription}>
                                        <div className={style.listTitle}>
                                            <div className={style.svgTitle}>
                                                <img src={svgIconJs} alt="svgIconJs" />
                                            </div>
                                            <div className={style.descriptionList}>
                                                <h3>Front-end Pro</h3>
                                                <span>17.11.2022-07.05.2023</span>
                                            </div>
                                        </div>
                                        <li>
                                            <p className={style.descriptionLi}>Assessment</p>
                                            <p className={style.appraisal__certificate}>Very Good</p>
                                        </li>
                                        <li>
                                            <p className={style.descriptionLi}>Average score</p>
                                            <p style={{color: "#fed530"}} className={style.appraisal__certificate}>89</p>
                                        </li>
                                    </ul>
                                    <ul className={style.listLink}>
                                        <li>
                                            <a href={certificateFrontProPdf} download>
                                                <Button variant='contained'>Download</Button>
                                            </a>
                                        </li>
                                        <li>
                                            <a target='_blank' href="https://certificate.ithillel.ua/view/22887759">
                                                <Button variant='contained' sx={{
                                                    padding: "6px 35px"
                                                }}>Open</Button>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Certificate